module.exports = __webpack_public_path__ + "img/icon-mew-wallet.f29574d3.png";